import { SupplierForm } from "../SupplierForm";

export interface AddSupplierProps {}

export const AddSupplier = () => {
  return <SupplierForm />;
};
